var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-tabs mb-3"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.activeTab === 'upload'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'upload'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload mr-2"
  }), _vm._v(" Upload Section\r\n      ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.activeTab === 'reports'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'reports'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-alt mr-2"
  }), _vm._v(" Reports Section\r\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content-area"
  }, [(_vm.activeTab === 'upload') ? _c('div', [_c('h6', {
    staticClass: "mb-4"
  }, [_vm._v("HR / Finance Recovery Upload")]), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', [_vm._v("Approval for")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approvalfor),
      expression: "approvalfor"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.approvalfor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "penaltydebitsrecovery"
    }
  }, [_vm._v("Manual Delivery Shipment Recovery")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', [_vm._v("Upload File")]), _vm._v(" "), _c('input', {
    ref: "files",
    staticClass: "form-control-file",
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.chooseFile1
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Only .csv files are allowed.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group d-flex"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clear1
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" Reset\r\n              ")])]), _vm._v(" "), (_vm.errorList1.length > 0) ? _c('div', [_c('h6', {
    staticClass: "text-danger"
  }, [_vm._v("Errors Found")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.errorList1), function(obj) {
    return _c('tr', {
      key: obj.lineNumber
    }, [_c('td', [_vm._v(_vm._s(obj.lineNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(obj.message))])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h6', {
    staticClass: "mt-2"
  }, [_vm._v("Sample Upload Formats")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item d-flex justify-content-between align-items-center"
  }, [_vm._v("\r\n                Manual Delivery Shipment Recovery\r\n                "), _c('i', {
    staticClass: "fa fa-download text-primary",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.downloadsampleformat1('penalty')
      }
    }
  })])])])]), _vm._v(" "), _vm._m(2)])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'reports') ? _c('div', [_c('h6', {
    staticClass: "mb-4"
  }, [_vm._v("Penalty Shipments Recovery Summary")]), _vm._v(" "), (_vm.isDownloadFlag) ? _c('div', {
    staticClass: "progress mb-3"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-striped progress-bar-animated",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("\r\n          Data is downloading... Please wait.\r\n        ")])]) : _c('div', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card shadow-sm mb-3"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "collapse show",
    attrs: {
      "id": "filterPanel"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', [_vm._v("From Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', [_vm._v("To Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', [_vm._v("Service Center")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.hubList,
      "selected-option": _vm.hublistObj,
      "name": "hubname",
      "placeholder": "Select hubname"
    },
    on: {
      "select": _vm.gethubname
    },
    model: {
      value: (_vm.hubname),
      callback: function($$v) {
        _vm.hubname = $$v
      },
      expression: "hubname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', [_vm._v("Debit From")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.debitFromList,
      "selected-option": _vm.debitFromObj,
      "name": "debitFrom",
      "placeholder": "Select debitFrom"
    },
    on: {
      "select": _vm.getDebitFrom
    },
    model: {
      value: (_vm.debitFrom),
      callback: function($$v) {
        _vm.debitFrom = $$v
      },
      expression: "debitFrom"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', [_vm._v("Employee ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employeeID),
      expression: "employeeID"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.employeeID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.employeeID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', [_vm._v("Shipping ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    attrs: {
      "options": _vm.StatusList,
      "selected-option": _vm.StatusObj,
      "name": "status",
      "placeholder": "Select status"
    },
    on: {
      "select": _vm.getStatus
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('status')),
      expression: "errors.has('status')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('status')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 d-flex align-items-end"
  }, [_c('button', {
    staticClass: "btn btn-success mr-2",
    on: {
      "click": _vm.searchData
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\r\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.filterclear
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset\r\n                    ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info d-flex justify-content-between align-items-center"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.totalRecords))]), _vm._v(" results found\r\n            ")]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive table-scroll-wrapper"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover custom-table"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [(_vm.HRDebitData.length > 0) ? _vm._l((_vm.HRDebitData), function(row, index) {
    return _c('tr', {
      key: row.Shippingid
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.DebitFromType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getDebitFromId(row)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.DebitFrom))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.AgencyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.agencyPanNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.NetShipmentValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Penalty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.DebitAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.totalrecoveredamount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalRemainingAmount))]), _vm._v(" "), _c('td', [_c('span', {
      class: row.Status == 'AccountCloseDebit' || row.Status == 'PartialDebit' ? 'badge badge-success' : 'badge badge-danger'
    }, [_vm._v("\r\n                        " + _vm._s(row.Status == 'AccountCloseDebit' ? 'Recovered' : row.Status == 'RMApprove' ? 'PendingRecovery' : row.Status) + "\r\n                      ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CreatedBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.LastModifiedDate)))])])
  }) : [_vm._m(6)]], 2)]), _vm._v(" "), _c('div', [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    staticClass: "rmApprove",
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.recoveryProcessedSummary = false
      }
    },
    model: {
      value: (_vm.recoveryProcessedSummary),
      callback: function($$v) {
        _vm.recoveryProcessedSummary = $$v
      },
      expression: "recoveryProcessedSummary"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.attachmentLoader
    },
    on: {
      "update:active": function($event) {
        _vm.attachmentLoader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Recovery Processed Summary / Output ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "btn btn-primary mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadProcessedRecoverySummary(_vm.recoveryuploadResult)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Summary Report\r\n               ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDebitFromModal
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto",
    class: {
      'isScroll': _vm.isScroll
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('span', {
    staticClass: "text-success mr-4"
  }, [_c('b', [_vm._v(" Recovered Successfull Count : " + _vm._s(_vm.successCount))])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger mr-4"
  }, [_c('b', [_vm._v(" Recovery Failed Count:  " + _vm._s(_vm.failureCount))])])]), _vm._v(" "), _c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Employee ID / PartnerID")]), _vm._v(" "), _c('th', [_vm._v("Recovery Status")]), _vm._v(" "), _c('th', [_vm._v("Remarks / Message")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.recoveryuploadResult), function(val1, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val1.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.userid))]), _vm._v(" "), (val1.code == 200) ? _c('td', [_c('label', {
      staticStyle: {
        "background-color": "green",
        "color": "white",
        "padding": "3px"
      }
    }, [_vm._v(" Recovered ")])]) : _c('td', [_c('label', {
      staticStyle: {
        "background-color": "red",
        "color": "white",
        "padding": "3px"
      }
    }, [_vm._v(" Not Recovered ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.recoverystatus))])])
  }), 0)])])])])], 1)], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary mr-2",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload\r\n              ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("Line Number")]), _vm._v(" "), _c('th', [_vm._v("Error")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info mt-4 penaltyuploadinstructions"
  }, [_c('strong', [_vm._v("Note (*)")]), _vm._v(" "), _c('ul', {
    staticClass: "mb-0"
  }, [_c('li', [_vm._v("File Format extension (.csv) should be allowed only.")]), _vm._v(" "), _c('li', [_vm._v("File headers should be case sensitive and must be uppercase.")]), _vm._v(" "), _c('li', [_vm._v("All columns are mandatory to fill in the file.")]), _vm._v(" "), _c('li', [_vm._v("Maximum limit for the number of records in the file is 100.")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header d-flex justify-content-between align-items-center"
  }, [_c('h6', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filters")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary btn-sm"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export CSV\r\n            ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Debit From Type")]), _vm._v(" "), _c('th', [_vm._v("EmployeeID / Partner ID")]), _vm._v(" "), _c('th', [_vm._v("Debit From")]), _vm._v(" "), _c('th', [_vm._v("Agency Name")]), _vm._v(" "), _c('th', [_vm._v("Agency PAN")]), _vm._v(" "), _c('th', [_vm._v("Shipment Value")]), _vm._v(" "), _c('th', [_vm._v("Penalty Amount")]), _vm._v(" "), _c('th', [_vm._v("Total Debit")]), _vm._v(" "), _c('th', [_vm._v("Recovered")]), _vm._v(" "), _c('th', [_vm._v("Remaining")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Debit Created By")]), _vm._v(" "), _c('th', [_vm._v("Debit Created Date")]), _vm._v(" "), _c('th', [_vm._v("Recovered Date")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Records..")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acd670a2","hasScoped":true}!./src/views/components/LOST/shipmentRecoveryApproval/shipmentRecoveryApproval.component.html
// module id = 1606
// module chunks = 1